'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var VIEW = 'view';
var ENGAGEMENT = 'engagement';

exports.default = {
    VIEW: VIEW,
    ENGAGEMENT: ENGAGEMENT
};
//# sourceMappingURL=type-names.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/type-names.js
 ** module id = 635
 ** module chunks = 1
 **/